import { render, staticRenderFns } from "./AcceptedClientPie.vue?vue&type=template&id=59d7173e&scoped=true&"
import script from "./AcceptedClientPie.vue?vue&type=script&lang=js&"
export * from "./AcceptedClientPie.vue?vue&type=script&lang=js&"
import style0 from "./AcceptedClientPie.vue?vue&type=style&index=0&id=59d7173e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d7173e",
  null
  
)

export default component.exports